// Configuration des couches WMS / WMTS / API officielles européennes
// Centralisé pour faciliter l'ajout de nouveaux pays

// === FRANCE - DGAC/IGN ===
// Source: Geoplateforme (data.geopf.fr) - même couche que cartes.gouv.fr
export const GEOPF_WMTS_URL = 'https://data.geopf.fr/wmts';
export const DGAC_DRONE_LAYER = 'TRANSPORTS.DRONES.RESTRICTIONS';

// === ALLEMAGNE - DIPUL WMS ===
// Source: Deutsche Flugsicherung (DFS) via uas-betrieb.de
export const DIPUL_WMS_URL = 'https://uas-betrieb.de/geoservices/dipul/wms';
export const DIPUL_LAYERS = [
  'kontrollzonen',              // Zones de contrôle (CTR)
  'flughaefen',                 // Aéroports
  'flugplaetze',                // Aérodromes
  'flugbeschraenkungsgebiete',  // Zones de restriction de vol (ED-R)
  'naturschutzgebiete',         // Réserves naturelles
  'nationalparks',              // Parcs nationaux
  'ffh-gebiete',                // Zones Natura 2000 (FFH)
  'vogelschutzgebiete',         // Zones de protection des oiseaux
];

// === ALLEMAGNE - DFS INSPIRE WMS ===
// Source: DFS Deutsche Flugsicherung - données INSPIRE Transport Aérien
export const DFS_INSPIRE_WMS_URL = 'https://haleconnect.com/ows/services/org.732.341f2791-919e-49de-8d86-3b18e040c430_wms';
export const DFS_AIRSPACE_LAYER = 'TN.AirTransportNetwork.AirSpaceArea';

// === BELGIQUE - AOEM WMS ===
// Source: NGI Belgium - DGTA/DGLV (Civil Aviation Authority)
export const BELGIUM_WMS_URL = 'https://wms.ngi.be/inspire/dgta_dglv/service';
export const BELGIUM_AOEM_LAYER = 'agl_aoem';

// === LUXEMBOURG - DAC UAS Geographical Zones ===
// Source: Géoportail Luxembourg (DAC) - g-o.lu/uas
// Layer 1927 = 0-50m AGL, Layer 1928 = 50-120m AGL (Eurocae ED-269 compliant)
export const LUXEMBOURG_WMS_URL = 'https://wms.geoportail.lu/public_map_layers/service';
export const LUXEMBOURG_UAS_LAYERS = '1927,1928';

// === PAYS-BAS - LVNL Drone No-Fly Zones (PDOK) ===
// Source: Luchtverkeersleiding Nederland (LVNL) via PDOK
// Couches officielles drone : zones aéronautiques + sites d'atterrissage
export const NETHERLANDS_WMS_URL = 'https://service.pdok.nl/lvnl/drone-no-flyzones/wms/v1_0';
export const NETHERLANDS_UAS_LAYERS = 'luchtvaartgebieden,landingsite';

// === SUISSE - FOCA / map.geo.admin.ch ===
// Source: Office Fédéral de l'Aviation Civile (OFAC/FOCA / BAZL)
// Couche WMTS officielle des restrictions UAS
export const SWITZERLAND_TILES_URL = 'https://wmts.geo.admin.ch/1.0.0/ch.bazl.einschraenkungen-drohnen/default/current/3857/{z}/{x}/{y}.png';

// === AUTRICHE - Austro Control INSPIRE View Service ===
// Source: Austro Control GeoServer (sdigeo-free.austrocontrol.at)
// Couche AirspaceArea : espace aérien autrichien (CTR, TMA, R, P, D)
export const AUSTRIA_WMS_URL = 'https://sdigeo-free.austrocontrol.at/geoserver/tn-a/wms';
export const AUSTRIA_AIRSPACE_LAYER = 'AirspaceArea';

// === POLOGNE - PANSA DroneTower (lien externe officiel) ===
// Pas de WMS public dédié drone. Couverture via OpenAIP + lien vers portail officiel
// pour la planification de vol et les autorisations.
export const POLAND_PORTAL_URL = 'https://dronemap.pansa.pl';

// === PORTUGAL - ANAC Voo de Drones (lien externe officiel) ===
// Pas de WMS public dédié drone. Couverture via OpenAIP + lien vers le webtool
// officiel ANAC pour les zones et la cartographie ED-269.
export const PORTUGAL_PORTAL_URL = 'https://dnt.anac.pt';

// === ESPAGNE - ENAIRE UAS Geographical Zones (ED-318) ===
// Source: Servicio Cartográfico ENAIRE (ais@enaire.es)
// Service ArcGIS publié sous standard EUROCAE ED-318
// WMS Layer names : "0" = Aero (AIRAC), "1" = Urbano, "2" = Infraestructuras
//   (⚠️ différents des IDs REST 2/3/0 — voir GetCapabilities du WMSServer)
export const SPAIN_ENAIRE_WMS_URL = 'https://servais.enaire.es/insigniads/services/NSF_SRV/SRV_UAS_ZG_data_V2/MapServer/WMSServer';
export const SPAIN_ENAIRE_LAYERS = '0,1,2';
export const SPAIN_ENAIRE_PORTAL_URL = 'https://drones.enaire.es';

// === ISLANDE - Samgöngustofa (Iceland Transport Authority) ===
// Source: Samgöngustofa via Náttúrufræðistofnun GeoServer (gis.natt.is)
// Couches officielles drone : dronemap + zones de fermeture temporaire (skyndilokanir)
// Licence : "Opin gögn LMÍ" (Open Data Iceland) — usage commercial autorisé avec attribution
export const ICELAND_WMS_URL = 'https://gis.natt.is/geoserver/wms';
export const ICELAND_DRONE_LAYERS = 'samgongustofa:dronemap_ice_geom,samgongustofa:skyndilokanir_dronar';

// === OPENAIP TILES - European Airspace Data ===
// Source: OpenAIP.net - Comprehensive aeronautical data for Europe
// Key sourced from REACT_APP_OPENAIP_KEY env var so it never lands in git history.
// NOTE: tile-provider keys are inherently visible in browser network requests —
// rotation and provider-side domain restriction (set on openaip.net dashboard)
// are the real defence here, env-var sourcing just keeps source tree clean.
export const OPENAIP_API_KEY = process.env.REACT_APP_OPENAIP_KEY || '';
export const OPENAIP_TILES_URL = 'https://{s}.api.tiles.openaip.net/api/data/openaip/{z}/{x}/{y}.png?apiKey=' + OPENAIP_API_KEY;

// === GEOCODAGE & VECTEURS ===
export const GEOCODE_API = 'https://nominatim.openstreetmap.org/search';
export const VECTOR_TILES_URL = 'https://app.dronekeeper.com/tegola/maps';

// Pays supportés pour la recherche
// FR, DE, BE, LU, IT, ES, NL, CH, AT, PL, PT, IS, CZ, SK, DK, IE, EE, CY
export const SUPPORTED_COUNTRIES = ['fr', 'de', 'be', 'lu', 'it', 'es', 'nl', 'ch', 'at', 'pl', 'pt', 'is', 'cz', 'sk', 'dk', 'ie', 'ee', 'cy'];
